import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

function getContentFromDataUrl(dataURL) {
  return dataURL.split(/,/)[1];
}

export function isDataUrl(url) {
  return url.search(/^(data:)/) !== -1;
}
export function makeDataUrl(content, mimeType) {
  return "data:".concat(mimeType, ";base64,").concat(content);
}
export function fetchAsDataURL(_x, _x2, _x3) {
  return _fetchAsDataURL.apply(this, arguments);
}

function _fetchAsDataURL() {
  _fetchAsDataURL = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, init, process) {
    var res, blob;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(url, init);

          case 2:
            res = _context.sent;

            if (!(res.status === 404)) {
              _context.next = 5;
              break;
            }

            throw new Error("Resource \"".concat(res.url, "\" not found"));

          case 5:
            _context.next = 7;
            return res.blob();

          case 7:
            blob = _context.sent;
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var reader = new FileReader();
              reader.onerror = reject;

              reader.onloadend = function () {
                try {
                  resolve(process({
                    res: res,
                    result: reader.result
                  }));
                } catch (error) {
                  reject(error);
                }
              };

              reader.readAsDataURL(blob);
            }));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchAsDataURL.apply(this, arguments);
}

var cache = {};

function getCacheKey(url, contentType, includeQueryParams) {
  var key = url.replace(/\?.*/, '');

  if (includeQueryParams) {
    key = url;
  } // font resource


  if (/ttf|otf|eot|woff2?/i.test(key)) {
    key = key.replace(/.*\//, '');
  }

  return contentType ? "[".concat(contentType, "]").concat(key) : key;
}

export function resourceToDataURL(_x4, _x5, _x6) {
  return _resourceToDataURL.apply(this, arguments);
}

function _resourceToDataURL() {
  _resourceToDataURL = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resourceUrl, contentType, options) {
    var cacheKey, dataURL, content, msg;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            cacheKey = getCacheKey(resourceUrl, contentType, options.includeQueryParams);

            if (!(cache[cacheKey] != null)) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", cache[cacheKey]);

          case 3:
            // ref: https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest#Bypassing_the_cache
            if (options.cacheBust) {
              // eslint-disable-next-line no-param-reassign
              resourceUrl += (/\?/.test(resourceUrl) ? '&' : '?') + new Date().getTime();
            }

            _context2.prev = 4;
            _context2.next = 7;
            return fetchAsDataURL(resourceUrl, options.fetchRequestInit, function (_ref) {
              var res = _ref.res,
                  result = _ref.result;

              if (!contentType) {
                // eslint-disable-next-line no-param-reassign
                contentType = res.headers.get('Content-Type') || '';
              }

              return getContentFromDataUrl(result);
            });

          case 7:
            content = _context2.sent;
            dataURL = makeDataUrl(content, contentType);
            _context2.next = 17;
            break;

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](4);
            dataURL = options.imagePlaceholder || '';
            msg = "Failed to fetch resource: ".concat(resourceUrl);

            if (_context2.t0) {
              msg = typeof _context2.t0 === 'string' ? _context2.t0 : _context2.t0.message;
            }

            if (msg) {
              console.warn(msg);
            }

          case 17:
            cache[cacheKey] = dataURL;
            return _context2.abrupt("return", dataURL);

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[4, 11]]);
  }));
  return _resourceToDataURL.apply(this, arguments);
}